'use strict';
import { defaults } from '@pnotify/core';

export class MxDebugHelper {
	get notificationDelay() {
		return defaults.delay;
	}

	set notificationDelay(delay) {
		defaults.delay = delay;
	}
}

mx.debugHelper = new MxDebugHelper();
